import React from 'react';
import './Safety.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';

const Safety = () => {
    return (
        <section className='safty-section pt-100 section-bg section-common pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle 
                    subTitle="GÜVENLİK"
                    title="Tedavinin her aşamasında güvenliği önce tutuyoruz"
                    description="Sterilizasyon, hijyen ve hasta takibi süreçlerimizi titizlikle uygulayarak güvenli bir klinik deneyimi sunuyoruz."
                />

                <div className="safety-video ratio ratio-16x9">
                    <iframe src="https://www.youtube.com/embed/f4jG8BCl5s0" title="Tanıtım videosu" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
                    </iframe>
                </div>
            </div>
        </section>
    );
};

export default Safety;